import { Grid } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { BigPlayButton, ControlBar, Player, Shortcut, ReplayControl, ForwardControl } from 'video-react';

const VideoBienvenida = (props) => {
    const { link, desbloquea, bloqueado = true } = props;
    const [bloqueo, setBloqueo] = useState(true);
    const shortCut = [
        { keyCode: 39, ctrl: false, handle: () => {} },
        { keyCode: 37, ctrl: false, handle: () => {} },
        { keyCode: 74, ctrl: false, handle: () => {} },
        { keyCode: 75, ctrl: false, handle: () => {} },
        { keyCode: 76, ctrl: false, handle: () => {} }
    ];

    const desbloqPlayer = () => {
        setBloqueo(false);
        desbloquea();
    };
    useEffect(() => {
        setBloqueo(bloqueado);
    }, [bloqueado]);

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} display="flex" justifyContent="end">
                <Player disableCompletely={bloqueo} playsInline poster="/assets/poster.png" src={link} onEnded={desbloqPlayer}>
                    <Shortcut shortcuts={shortCut} />
                    <BigPlayButton position="center" />
                    <ControlBar disableCompletely={bloqueo}>
                        {!bloqueo && <ReplayControl seconds={10} order={1} />}
                        {!bloqueo && <ForwardControl seconds={10} order={2} />}
                    </ControlBar>
                </Player>
            </Grid>
        </Grid>
    );
};

export default VideoBienvenida;
